"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _autoCompleteModule = _interopRequireDefault(require("./auto-complete.module.css"));

var _actions = require("../../actions");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var AutoComplete =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AutoComplete, _React$Component);

  function AutoComplete(props) {
    var _this;

    _classCallCheck(this, AutoComplete);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AutoComplete).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "search", (0, _lodash.default)(function (text) {
      var dataSrc = _this.props.dataSrc; // eslint-disable-next-line no-undef

      fetch("".concat(dataSrc, "?term=").concat(text), {
        credentials: "same-origin"
      }).then(_actions.checkStatus).then(_actions.parseJSON).then(function (data) {
        _this.setState({
          showSuggestions: true,
          suggestions: data
        });
      }).catch(function (err) {
        return console.log(err);
      });
    }, 500));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (text) {
      _this.setState({
        value: text
      });

      _this.search(text);
    });

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (key, label) {
      var onSelect = _this.props.onSelect;

      if (onSelect) {
        onSelect(key, label);
      }

      _this.setState({
        value: label
      });

      _this.setState({
        suggestions: []
      });
    });

    _this.state = {
      showSuggestions: false,
      suggestions: [],
      value: props.value,
      valueSet: 0
    };
    return _this;
  }

  _createClass(AutoComplete, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.search.cancel();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          name = _this$props.name,
          className = _this$props.className,
          placeholder = _this$props.placeholder,
          style = _this$props.style;
      var _this$state = this.state,
          showSuggestions = _this$state.showSuggestions,
          suggestions = _this$state.suggestions,
          value = _this$state.value;
      return _react.default.createElement("div", {
        className: _autoCompleteModule.default.autoCompleteContainer
      }, _react.default.createElement("input", {
        type: "text",
        name: name,
        className: className,
        value: value,
        onChange: function onChange(e) {
          return _this2.onChange(e.target.value);
        },
        onFocus: function onFocus() {
          return _this2.setState({
            showSuggestions: true
          });
        },
        autoComplete: "off",
        placeholder: placeholder,
        style: style
      }), showSuggestions && suggestions && suggestions.length > 0 && _react.default.createElement(Dropdown, {
        items: suggestions,
        onClick: this.onSelect
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, currentState) {
      if (currentState.value === "" && props.value !== "" && currentState.valueSet === 0) {
        return {
          value: props.value,
          valueSet: 1
        };
      }

      return null;
    }
  }]);

  return AutoComplete;
}(_react.default.Component);

var Dropdown = function Dropdown(_ref) {
  var items = _ref.items,
      style = _ref.style,
      _onClick = _ref.onClick;
  return _react.default.createElement("ul", {
    style: style,
    className: _autoCompleteModule.default.list
  }, items.map(function (item) {
    return _react.default.createElement("li", {
      className: _autoCompleteModule.default.item,
      key: item.id,
      onClick: function onClick() {
        return _onClick(item.id, item.value);
      }
    }, item.label);
  }));
};

var _default = AutoComplete;
exports.default = _default;